// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const InsertTableConstants = {
  CELL_SIZE: 19,
  CELL_PADDING: 2,
  MAX_ROWS: 20,
  MAX_COLS: 20,
};
export default InsertTableConstants;
